import { Injectable } from '@angular/core';
import { AutopayStatus } from '../../chords/payment-card/payment-card.model';

@Injectable({
  providedIn: 'root',
})
export class AutopayService {
  getAutopayIcon(type): string {
    switch (type) {
      case AutopayStatus.ALERT:
      case AutopayStatus.WARNING:
        return 'warning';
      case AutopayStatus.SUCCESS:
        return 'check';
      case AutopayStatus.INFORMATION:
        return 'info';
    }
  }

  getAutopayType(type): string {
    switch (type) {
      case AutopayStatus.ALERT:
        return 'error';
      case AutopayStatus.WARNING:
        return 'warning';
      case AutopayStatus.SUCCESS:
        return 'success';
      case AutopayStatus.INFORMATION:
      default:
        return 'information';
    }
  }
}
